export default "__VITE_ASSET__CDNc8zwQ__"